import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');



const RenderWpForm = () => {

const resturl=sessionStorage.getItem("RESTURL");
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});



const [rqsdates, setRqsdates] = useState([]);
const [rqsdateopts, setRqsdateopts] = useState([]);

const [tbllcreqs, setTbllcreqs] = useState([]);
const [crit, setCrit] = useState({txt:''
, date1:''
, date2:''
, noresp:0
, applyfilter:true
});

const [dowait, setDowait] = useState({on:false});

const location = useLocation();


useEffect(() => {

if (tbllcreqs.length<1){
	gettbllcreqs();
	}//end if
	//qrylabor();
 },[]);

useEffect(() => {
	document.getElementsByName('txt')[0].focus();
	
 },[JSON.stringify(tbllcreqs)]);



useEffect(() => {
	
console.log("rqsdates: "+JSON.stringify(rqsdates));

	if (rqsdates.length>0){
		let temp=[];
		rqsdates.map((col, index) => {
			const key="rqsdateopt_"+index;
			const val=col['VAL'];
			const opt=col['OPT'];
			
			temp.push(<option key={key} value={val}  >{opt}</option>);
			});//end map
		setRqsdateopts(temp);
		}//end if
	
 },[JSON.stringify(rqsdates)]);



useEffect(() => {
	
	if (!crit.date1 || !crit.date2 )
		return;
	
	if (crit.applyfilter==true)
		gettbllcreqs();
	else
		setCrit((prev)=>{
			return {...prev, applyfilter:true}
		});;
	
 },[crit.txt, crit.date1, crit.date2, crit.noresp]);

function handleChange(e){
	
	let {name, value} = e.target;
	
if (name=='noresp')
	value=e.target.checked==true?1:0;

console.log("handleChange: "+name+", "+value);
	
		setCrit((prev)=>{
			return {...prev, [name]:value, applyfilter:true}
		});
	
	
}//end if

function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;
	
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func

async function gettbllcreqs(){

const params = {
	crit:crit
	};
	
console.log('params: '+JSON.stringify( params));
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
	setTbllcreqs([]);
	
  await fetch(customspremurl+'rarwptapp/gettbllcreqs',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettbllcreqs(res) )
      .catch(err => console.log(err));

}//end func


function aftergettbllcreqs(obj){
	
setRqsdates(obj[0].rqsdates);
const res=obj[0].res;
	
if (!res.length)
	return;
	
console.log('aftergettbllcreqs, res.length: '+res.length);

let rowcount=1;

let htmrows=[];
res.map((col, index) => {
	const WPT_APP_ID=col['WPT_APP_ID'];
	const trkey='tr_'+WPT_APP_ID;
	//const rdkey='rd_'+appid;
	if (rowcount==1 && crit.date1=="")
		setCrit((prev)=>{
			return {...prev, date1:col['DATE1'], date2:col['DATE2'], applyfilter:false}
			});
	
	const htmrow=<tr key={trkey} >
	<td align='right' >{rowcount}</td>
	<td align='center' dangerouslySetInnerHTML={{__html: col['RQS_DATE']}} ></td>
	<td align='center' dangerouslySetInnerHTML={{__html: col['RSP_DATE']}} ></td>
	<td align='left' >{col['WPT_APP_ID']}</td>
	<td align='left' >{col['LBR_CLR_APP_ID']}</td>
	<td align='left' >{col['AGENCY_ID']}</td>
	<td align='left' >{col['EMPL_ID']}</td>
	<td align='left' >{col['PERSON_ID']}</td>
	<td align='left' >{col['OCCUPATION_ID']}</td>
	<td align='left' title={col['AGENCY']} >{(col['AGENCY']??"").toString().substring(0,16)}</td>
	<td align='left' title={col['COMPANY']} >{(col['COMPANY']??"").toString().substring(0,16)}</td>
	<td align='left' title={col['PERSON']} >{(col['PERSON']??"").toString().substring(0,16)}</td>
	<td align='center' >{col['DOB']}</td>
	<td align='left' >{col['IMG_REF_NO']}</td>
	<td align='left' title={col['OCCUPATION']} >{(col['OCCUPATION']??"").toString().substring(0,16)}</td>
	<td align='left' >{col['LOCATION']}</td>
	</tr>;
	htmrows.push(htmrow);
	rowcount++;
});
	
setTbllcreqs(htmrows);
}//end func



function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func


function combodatechange(e){
	
setCrit((prev)=>{
	return {
	...prev
	, date1: e.target.value
	, date2: e.target.value
	}
	});
	
}//end func

	
  return (
    <>
	
<table align='center' style={{width:"60%", marginTop:"10px", marginBottom:"10px"}}>
<tbody>
<tr>
<td  align='center' >
	<input name='noresp' id='noresp' type='checkbox' onChange={(e)=>{handleChange(e);}}  />
	<label htmlFor='noresp' className="hand" >no response</label>
</td>
<td  align='center' >search criteria:</td>
<td  align='center' >
	<input name='txt' value={crit.txt} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{e.target.select();}} placeholder='search by name' />
</td>
<td  align='center' >
	<input name='date1' value={crit.date1} onChange={(e)=>{handleChange(e);}}  type='date' />
</td>
<td  align='center' >
	<input name='date2' value={crit.date2} onChange={(e)=>{handleChange(e);}}  type='date' />
</td>
</tr>
</tbody>
</table>
	
	<table align='center' className='customers' style={{width:"98%"}} >
	<thead>
	<tr>
		<th>#</th>
		<th><select onChange={(e)=>{combodatechange(e);}} ><option value='' >- dates -</option>{rqsdateopts}</select></th>
		<th>resp.<br/>date</th>
		<th>Wptapp<br/>Id</th>
		<th>Lbr<br/>clr Id</th>
		<th>AGENCY<br/>ID</th>
		<th>EMPLR<br/>ID</th>
		<th>PERSON<br/>ID</th>
		<th>OCCUP<br/>ID</th>
		<th>AGENCY</th>
		<th>EMPLOYER</th>
		<th>PERSON</th>
		<th>DOB</th>
		<th>IMG_REF</th>
		<th>OCCUPATION</th>
		<th>LOCATION</th>

	</tr>
	</thead>
	<tbody>
		{tbllcreqs}
	</tbody>
	</table>


<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderWpForm;